import React from "react";
import { ScanFlowV2 } from "crossdock/common/flow/ScanFlowV2";
import { createPrintInboundPalletLabelAsnCard } from "./InboundPalletLabelCardCreators";

export const PrintInboundPalletLabel: React.FC = () => (
  <ScanFlowV2 onMountCardData={createPrintInboundPalletLabelAsnCard({})} />
);
